import { render, staticRenderFns } from "./review-analysis-header.vue?vue&type=template&id=546aef1c&scoped=true&"
import script from "./review-analysis-header.vue?vue&type=script&lang=js&"
export * from "./review-analysis-header.vue?vue&type=script&lang=js&"
import style0 from "./review-analysis-header.vue?vue&type=style&index=0&id=546aef1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546aef1c",
  null
  
)

export default component.exports